import $ from 'jquery';

$(function () {
    $('.hideShow').show();
    let $span = $('.hideShow span');
    $span.addClass('show');

    $span.click(function () {
        if ($(this).hasClass('show')) {
            $(this).parent().prev('input').attr('type', 'text');
            $(this).removeClass('show');
        } else {
            $(this).parent().prev('input').attr('type', 'password');
            $(this).addClass('show');
        }
    });

    $('form button[type="submit"]').on('click', function () {
        $('.hideShow').prev('input').attr('type', 'password');
    });
});
/**
 * Created by marcbrautmeier on 04.04.17.
 */
